var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6  sm:justify-center z-50"
    },
    [
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "transform ease-out duration-300 transition",
            "enter-class":
              "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
            "leave-active-class": "transition ease-in duration-100",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNotification,
                  expression: "showNotification"
                }
              ],
              staticClass: "Polaris-Frame-ToastManager",
              attrs: { "aria-live": "assertive" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "Polaris-Frame-ToastManager__ToastWrapper Polaris-Frame-ToastManager--toastWrapperEnterDone",
                  staticStyle: {
                    "--pc-toast-manager-translate-y-in": "-66px",
                    "--pc-toast-manager-translate-y-out": "84px"
                  }
                },
                [
                  _c("div", { staticClass: "Polaris-Frame-Toast" }, [
                    _c(
                      "div",
                      {
                        staticClass: "Polaris-Inline",
                        staticStyle: {
                          "--pc-inline-block-align": "center",
                          "--pc-inline-wrap": "wrap",
                          "--pc-inline-gap-xs": "var(--p-space-4)"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "Polaris-Text--root Polaris-Text--medium capitalize"
                          },
                          [_vm._v(_vm._s(_vm.text))]
                        )
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "Polaris-Frame-Toast__CloseButton cursor-pointer z-50",
                        attrs: { type: "button" },
                        on: { click: _vm.close }
                      },
                      [
                        _c("span", { staticClass: "Polaris-Icon" }, [
                          _c("span", {
                            staticClass:
                              "Polaris-Text--root Polaris-Text--visuallyHidden"
                          }),
                          _c(
                            "svg",
                            {
                              staticClass: "Polaris-Icon__Svg",
                              attrs: {
                                viewBox: "0 0 20 20",
                                focusable: "false",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }